{
  "nl": {
    "pricingPlans": {
      "error": {
        "loading": "Fout bij het laden van het prijsoverzicht"
      },
      "index": {
        "headings": {
          "benefits": "De fobizz aanbiedingen in één oogopslag"
        },
        "newLayout": {
          "header": {
            "title": "Welke fobizz past bij jou?",
            "subtitle": "Wij ondersteunen je om je lessen interactiever en digitaler te maken"
          },
          "individualSection": {
            "title": "fobizz Individuele Licentie - Persoonlijk voor jou"
          },
          "groupSection": {
            "title": "fobizz samen met collega's gebruiken",
            "groupLicense": {
              "title": "Licenties voor Groepen",
              "descriptionHtml": "De groepslicentie is al voordelig vanaf <strong>5 personen</strong>.",
              "linkText": "Informatie over de groepslicentie",
              "url": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/"
            },
            "groupJoin": {
              "title": "Groepslicentie activeren",
              "description": "Heeft jouw instelling al een licentie?",
              "instruction": "Koppel hier je account:"
            }
          },
          "trialSection": {
            "title": "Nog niet zeker wat bij je past?",
            "description": "Activeer je gratis proefmaand en test vrijblijvend de volledige functionaliteit van het Combinatie-abonnement.",
            "placeholder": "Cadeaucode",
            "button": "Proefmaand starten",
            "error": "De cadeaucode is ongeldig."
          }
        },
        "paragraphs": {
          "benefitsIntro": "Met het Combinatie-abonnement kun je onbeperkt gebruikmaken van alle fobizz aanbiedingen. Met een gratis account kun je fobizz vrijblijvend testen, een deel van de scholingscatalogus gebruiken en ontvang je een maandelijks limiet voor de tools. Vergelijk alle mogelijkheden hier:"
        },
        "footer": {
          "pricingInfo": "Alle prijzen per persoon inclusief Duitse btw."
        },
        "limitsTable": {
          "unlimited": "Onbeperkt"
        }
      },
      "links": {
        "getStarted": "Nu aanmelden"
      }
    }
  }
}
